import { ReactNode } from 'react'
import cn from 'clsx'
import { Image } from '@tracklib/kit'
import styles from './coverart.css'

type Props = {
  cover?: string | number
  title?: string
  className?: string
  children?: JSX.Element | Array<ReactNode>
  compact?: boolean
  size?: 'auto'
  sizes?: string
}

const CoverArt = ({ cover, title, className, children, compact, size, sizes }: Props): JSX.Element => {
  const getSizes = (): string => {
    if (sizes) {
      return sizes
    }
    if (compact) {
      return '64px'
    }
    return '(min-width: 769px) 130px, 50px'
  }

  return (
    <div className={cn(styles.coverArt, size === 'auto' && styles.auto, className)}>
      <Image
        image={cover}
        absolute
        imageWidths={[64, 128, 130, 260, 520]}
        sizes={getSizes()}
        className={styles.image}
        alt={`${title} cover art`}
      />
      {!cover && <div className={styles.title}>{title}</div>}
      {children}
    </div>
  )
}

export default CoverArt
